import fetch from '@/fetch'

const cache = new Map()
const isTaskRelated = async (task, lead) => {
  if (task.reference.onModel === 'Lead') return task.reference.ref === lead
  const relations = await getTaskRelations(task, 'Lead')
  return relations.includes(lead)
}

const getTaskRelations = (task, target) => {
  if (cache.has(task.id)) return cache.get(task.id)
  const promise = new Promise((resolve, reject) => {
    fetch(`/api/task/${task.id}/resolve-references/${target}`)
      .then(res => res.json())
      .then(data => resolve(data))
      .catch(() => reject(false))
      .finally(() => cache.delete(task.id))
  })
  cache.set(task.id, promise)

  return promise
}

export { isTaskRelated, getTaskRelations }
